module.exports = '3.0.0-development';
